import React, { FC, Fragment, ChangeEvent } from 'react';
import { useFormikContext } from 'formik';
import { Grid, Switch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { GetSharePreviewInfoQuery, SocialAccount } from 'api';
import { SocialAccountIcon } from 'components';

import { INetwork, IShare } from '../types';
import { Accounts } from './';
import Commentary from './Commentary';

interface IProps {
  accounts: SocialAccount[];
  network: INetwork;
  onConnect: (network: INetwork) => void;
  previewInfo: GetSharePreviewInfoQuery['getSharePreviewInfo'];
}

const useStyles = makeStyles(theme => ({
  switch: {
    right: -theme.spacing(2),
  },
}));

const ActiveAuth: FC<IProps> = props => {
  const { accounts, network, onConnect, previewInfo } = props;

  const classes = useStyles();
  const formik = useFormikContext<IShare>();

  const { values } = formik;
  const { provider } = network;

  const item = values[provider];
  const { active, network_id } = item;
  const selectedAccount = accounts.find(account => account.id === network_id);

  function toggleNetwork(event: ChangeEvent<HTMLInputElement>) {
    formik.setFieldValue(`${network.provider}.active`, event.target.checked);
  }

  return (
    <Fragment>
      <Grid container alignItems="center" justify="space-between">
        <Grid item>
          <Grid container alignItems="center">
            <Grid item>
              <SocialAccountIcon size={32} active={active} provider={provider} />
            </Grid>
            <Grid item>
              {selectedAccount && (
                <Accounts
                  accounts={accounts}
                  selectedAccount={selectedAccount}
                  onConnect={() => onConnect(network)}
                  onChange={(account: SocialAccount) => {
                    formik.setFieldValue(`${provider}.network_id`, account.id);
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Switch className={classes.switch} checked={active} onChange={toggleNetwork} />
        </Grid>
      </Grid>
      <Commentary network={network} previewInfo={previewInfo} />
    </Fragment>
  );
};

export default ActiveAuth;
